import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NAV_LINKS } from "../lib/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      data-testid="site-navbar"
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#hero"
          data-testid="brand-logo"
          onClick={(e) => { e.preventDefault(); handleClick("#hero"); }}
          className="group flex items-center gap-3"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/j30fas3r_40BB10F5-2D42-4AAE-9504-A5FC7C4F46EA.PNG"
            alt="Mr. Green Bay"
            className="h-12 w-12 rounded-md object-contain transition-transform group-hover:scale-105 md:h-14 md:w-14"
          />
          <div className="hidden flex-col leading-none sm:flex">
            <span className="font-display text-sm font-bold tracking-wider text-white">
              CA$H OUT
            </span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-gold/80">
              Never Crash Out
            </span>
          </div>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
              className="text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:text-gold"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-book"
            onClick={() => handleClick("#speaking")}
            className="hidden btn-gold rounded-full px-5 py-2.5 text-xs font-semibold uppercase tracking-wider md:inline-flex"
          >
            Book Mr. Green Bay
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((o) => !o)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-black/50 text-white lg:hidden"
            aria-label="Toggle menu"
          >
            <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-white/5 bg-ink-900/95 backdrop-blur-xl lg:hidden"
          >
            <div className="mx-auto flex max-w-7xl flex-col gap-1 px-6 py-6">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.href}
                  data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
                  onClick={() => handleClick(link.href)}
                  className="rounded-lg px-3 py-3 text-left text-sm uppercase tracking-[0.2em] text-zinc-200 hover:bg-white/5 hover:text-gold"
                >
                  {link.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-cta"
                onClick={() => handleClick("#speaking")}
                className="btn-gold mt-3 rounded-full px-5 py-3 text-xs font-semibold uppercase tracking-wider"
              >
                Book Mr. Green Bay
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
